import { Link } from 'react-router-dom';
import { ArrowRight, Trophy } from 'lucide-react';

import type { IdeaPoint } from '@/api/types';
import { opportunitiesHref } from '@/routes/business-opportunities/ideaFilters';
import { useIdeaLink } from '@/routes/business-opportunities/ideaUi';
import { ScoreValue } from '@/ui/ScoreValue';

export const LEADERBOARD = 5;

/** The scored active ideas with the highest totals (the points come best first). */
export function TopIdeasCard({ points }: { points: IdeaPoint[] }) {
  const ideaLink = useIdeaLink();
  const top = points.filter((idea) => idea.total !== null).slice(0, LEADERBOARD);
  return (
    <section className="card" aria-labelledby="dash-top">
      <div className="card-head">
        <h3 id="dash-top">
          <Trophy aria-hidden="true" className="dash-trophy" /> Top {LEADERBOARD}
        </h3>
        <Link to={opportunitiesHref({ view: 'list', dispositions: ['active'] })} className="dash-more">
          All ideas <ArrowRight aria-hidden="true" />
        </Link>
      </div>
      {top.length === 0 ? (
        <div className="card-body">
          <p className="hint">No active idea has been scored yet.</p>
        </div>
      ) : (
        <ol className="leaderboard">
          {top.map((idea, index) => (
            <li key={idea.id}>
              <span className={`lb-rank${index < 3 ? ' is-podium' : ''}`}>{index + 1}</span>
              <span className="lb-idea">
                <Link {...ideaLink(idea.id)} className="idea-link">
                  {idea.title}
                </Link>
                <span className="lb-industry">{idea.industry?.name ?? 'Unassigned'}</span>
              </span>
              <ScoreValue value={idea.total} />
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
